import $ from 'jquery';

const mobileMenuTriggerInit = () => {
    const $trigger = $('.c-mobile-nav-trigger');
    const $mobileMenu = $('.mobile-nav');
    const $mobileSearchClose = $('.mobile-search-close');
    const $mobileSearchContainer = $('.mobile-search-container');
    const activeClass = 'is-active';
    const bodyActiveClass = 'mobile-menu-is-active';

    if ($trigger.length) {
        $trigger.on('click', () => {
            $(this).toggleClass(activeClass);
            $mobileMenu.toggleClass(activeClass);
            $('body').toggleClass(bodyActiveClass);
            // Reset Menu On Toggle
            $('.submenu-active').removeClass('submenu-active');
            $('.has-active-submenu').removeClass('has-active-submenu');
            $('.c-primary-links').css('transform', 'translateX(0%)');
            document.getElementsByClassName('entry')[0].style.display = 'flex';
            $mobileSearchContainer.removeClass(activeClass);
        });
    }

    if ($mobileSearchClose.length) {
        $mobileSearchClose.on('click', () => {
            $mobileSearchContainer.removeClass(activeClass);
        });
    }
};

// doc ready
$(() => {
    mobileMenuTriggerInit();
});
